var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v("Nombre d'heures à payer")]),
    _vm._v(" "),
    _c(
      "table",
      {
        staticClass: "table table-bordered table-compact paid-hours-table",
        staticStyle: { width: "auto" }
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.regularHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.sicknessHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.holidayHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.vacationHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.bankHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right bold" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.paidHours)))
            ])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v(" ")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.allocation.sicknessHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.allocation.holidayHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.allocation.vacationHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(-_vm.allocation.bankHours)))
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(" ")])
          ]),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v(" ")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.adjustments.sicknessHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.adjustments.holidayHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.adjustments.vacationHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(-_vm.adjustments.bankHours)))
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(" ")])
          ]),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v(" ")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.sicknessHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.holidayHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(_vm.totals.vacationHours)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-right" }, [
              _vm._v(_vm._s(_vm.formatDigit(Math.max(_vm.totals.bankHours, 0))))
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(" ")])
          ]),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v(" ")]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "text-right",
                class: { "cell-alert": _vm.sicknessHourDiff < 0 }
              },
              [_vm._v(_vm._s(_vm.formatDigit(_vm.sicknessHourDiff)))]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "text-right",
                class: { "cell-alert": _vm.holidayHourDiff < 0 }
              },
              [_vm._v(_vm._s(_vm.formatDigit(_vm.holidayHourDiff)))]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "text-right",
                class: { "cell-alert": _vm.vacationHoursDiff < 0 }
              },
              [_vm._v(_vm._s(_vm.formatDigit(_vm.vacationHoursDiff)))]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "text-right",
                class: { "cell-alert": _vm.bankHourDiff < 0 }
              },
              [_vm._v(_vm._s(_vm.formatDigit(_vm.bankHourDiff)))]
            ),
            _vm._v(" "),
            _c("td", [_vm._v(" ")])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", [_vm._v("Régulier")]),
      _vm._v(" "),
      _c("th", [_vm._v("Maladie")]),
      _vm._v(" "),
      _c("th", [_vm._v("Congés fériés")]),
      _vm._v(" "),
      _c("th", [_vm._v("Vacances")]),
      _vm._v(" "),
      _c("th", [_vm._v("Banque d'heure")]),
      _vm._v(" "),
      _c("th", [_vm._v("Total payé")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", {
        staticStyle: { "background-color": "gray", height: "3px" },
        attrs: { colspan: "6" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "bold", attrs: { colspan: "6" } }, [
        _vm._v("Allocation initiale")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "bold", attrs: { colspan: "6" } }, [
        _vm._v("Plus ajustement")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "bold", attrs: { colspan: "6" } }, [
        _vm._v("Moins utilisé")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "bold", attrs: { colspan: "6" } }, [
        _vm._v("Allocation restantes")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }